var _rect, _rect2, _g, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 846,
    transform: "translate(-120 -441)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.332 9.16699C14.7154 9.16699 15.8237 8.05033 15.8237 6.66699C15.8237 5.28366 14.7154 4.16699 13.332 4.16699C11.9487 4.16699 10.832 5.28366 10.832 6.66699C10.832 8.05033 11.9487 9.16699 13.332 9.16699ZM6.66536 9.16699C8.0487 9.16699 9.15703 8.05033 9.15703 6.66699C9.15703 5.28366 8.0487 4.16699 6.66536 4.16699C5.28203 4.16699 4.16536 5.28366 4.16536 6.66699C4.16536 8.05033 5.28203 9.16699 6.66536 9.16699ZM6.66536 10.8337C4.7237 10.8337 0.832031 11.8087 0.832031 13.7503V15.0003C0.832031 15.4587 1.20703 15.8337 1.66536 15.8337H11.6654C12.1237 15.8337 12.4987 15.4587 12.4987 15.0003V13.7503C12.4987 11.8087 8.60703 10.8337 6.66536 10.8337ZM13.332 10.8337C13.0904 10.8337 12.8154 10.8503 12.5237 10.8753C12.5404 10.8837 12.5487 10.9003 12.557 10.9087C13.507 11.6003 14.1654 12.5253 14.1654 13.7503V15.0003C14.1654 15.292 14.107 15.5753 14.0154 15.8337H18.332C18.7904 15.8337 19.1654 15.4587 19.1654 15.0003V13.7503C19.1654 11.8087 15.2737 10.8337 13.332 10.8337Z",
    fill: "#2E2B2E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -225.5,
    width: 379,
    height: 530,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPeople);
export default __webpack_public_path__ + "static/media/icn_people.cca7416550c1e999d29e2e9e6e162125.svg";
export { ForwardRef as ReactComponent };